import {Navigate, createBrowserRouter} from 'react-router-dom';

import Home from '@/pages/Home'
import OurProducts from '@/pages/OurProducts'
import ProductDetail from '@/pages/ProductDetail'
import ContactUs from '@/pages/ContactUs'
import AboutUs from '@/pages/AboutUs'
import SignupLogin from '@/pages/SignupLogin'
import ShoppingCart from '@/pages/ShoppingCart'
import PrivacyPolicy from '@/pages/PrivacyPolicy'
import TermsOfService from '@/pages/TermsOfService'
import MyProfile from '@/pages/MyProfile'
import EditOrder from '@/pages/EditOrder'
import EditOrderProducts from '@/pages/EditOrderProducts'
import EditOrderProductDetail from "@/pages/EditOrderProductDetail";
import Search from "@/pages/Search"
import {getToken} from '@/common';

const isLogged = !!getToken()

const router = createBrowserRouter([
  {
    path: '/home',
    // element: isLogged ? <Home /> : <Navigate to="/signupLogin" />
    element: isLogged ? <OurProducts /> : <Navigate to="/signupLogin" />
  },
  {
    path: '/ourProducts',
    element: isLogged ? <OurProducts /> : <Navigate to="/signupLogin" />,
  },
  {
    path: '/ourProducts/:group',
    element: isLogged ? <OurProducts /> : <Navigate to="/signupLogin" />,
  },
  {
    path: '/ourProducts/:group/:category',
    element: isLogged ? <OurProducts /> : <Navigate to="/signupLogin" />,
  },
  {
    path: '/ourProducts/category2/:category2',
    element: isLogged ? <OurProducts /> : <Navigate to="/signupLogin" />,
  },
  {
    path: '/productDetail/:id',
    element: isLogged ? <ProductDetail /> : <Navigate to="/signupLogin" />,
  },
  {
    path: '/contactUs',
    element: <ContactUs />,
  },
  {
    path: '/aboutUs',
    element: <AboutUs />,
  },
  {
    path: '/signupLogin',
    element: <SignupLogin />,
  },
  {
    path: '/shoppingCart',
    element: isLogged ? <ShoppingCart /> : <Navigate to="/signupLogin" />,
    
  },
  {
    path: '/privacyPolicy',
    element: <PrivacyPolicy />,
    // element: isLogged ? <PrivacyPolicy /> : <Navigate to="/signupLogin" />,
  },
  {
    path: '/termsOfService',
    element: <TermsOfService />,
    // element: isLogged ? <TermsOfService /> : <Navigate to="/signupLogin" />,
  },
  {
    path: '/myProfile',
    element: isLogged ? <MyProfile /> : <Navigate to="/signupLogin" />,
    
  },
  {
    path: '/editOrder/:id',
    element: <EditOrder />,
    element: isLogged ? <OurProducts /> : <Navigate to="/signupLogin" />,
    
  },
  {
    path: '/editOrderProducts',
    element: isLogged ? <EditOrderProducts /> : <Navigate to="/signupLogin" />,
    
  },
  {
    path: '/editOrderProducts/:group',
    element: isLogged ? <EditOrderProducts /> : <Navigate to="/signupLogin" />,
    
  },
  {
    path: '/editOrderProducts/:group/:category',
    element: isLogged ? <EditOrderProducts /> : <Navigate to="/signupLogin" />,
    
  },
  {
    path: '/editOrderProductDetail/:id',
    element: isLogged ? <EditOrderProductDetail /> : <Navigate to="/signupLogin" />,
    
  },
  {
    path: '/search',
    element: isLogged ? <Search /> : <Navigate to="/signupLogin" />,
  },
  {
    path: '*',
    element: <Navigate to={'/home'} replace={true} />
  },
]);

export default router
